<template>
  <div ref="paypal"></div>
</template>

<script>
import Panier from "../classes/Panier.js";
import { auth } from "@/firebase";
const { Profile } = require("../classes/Profile.js");
const { Vente } = require("../classes/Vente.js");

export default {
  name: "PayPal",
  props: {
    panier: Panier,
    canPay: Boolean,
    pointRelais: Object,
  },
  data() {
    return {
      profile: undefined,
      loadingComponent: undefined,
    };
  },
  mounted: function () {
    const script = document.createElement("script");
    script.src =
      "https://www.paypal.com/sdk/js?client-id=AYZ_lZon7Ncu2oqBNsDfVWvotuUnvI3KmVB5N2LCRbyMrexPcmWpwfIVMCMmukZFWWKpttmBCnGdi8oX&currency=EUR";
    script.addEventListener("load", this.setLoaded);
    document.body.appendChild(script);
  },
  computed: {
    listeProduitsPanier() {
      return this.panier.liste;
    },
    itemsPaypal() {
      const items = [];
      for (let index = 0; index < this.listeProduitsPanier.length; index++) {
        const item = this.listeProduitsPanier[index];
        items.push({
          name: item.produit.nom,
          unit_amount: {
            currency_code: "EUR",
            value: item.produit.prix,
          },
          quantity: item.quantite,
        });
      }
      items.push({
        name: "Livraison",
        description: "Point relais via Mondial Relay",
        unit_amount: {
          currency_code: "EUR",
          value: this.panier.prixLivraison,
        },
        quantity: 1,
      });
      return items;
    },
  },
  methods: {
    async readData() {
      const profile = new Profile(auth.currentUser.uid);
      await profile.getProfile();
      this.profile = profile;
    },
    setLoaded() {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: async (data, actions) => {
            await this.readData();

            const profile = this.profile;

            return actions.order.create({
              payer: {
                name: {
                  given_name: profile.firstName,
                },
                email_address: profile.mail,
                phone: {
                  phone_number: { national_number: profile.tel },
                },
                address: {
                  address_line_1: profile.fullAddress.address,
                  country_code: "FR",
                  postal_code: profile.fullAddress.postalCode,
                  admin_area_2: profile.fullAddress.city,
                },
              },
              purchase_units: [
                {
                  description: "Achat chez O' Fil des Saisons",
                  amount: {
                    currency_code: "EUR",
                    value: this.panier.total,
                    breakdown: {
                      item_total: {
                        currency_code: "EUR",
                        value: this.panier.total,
                      },
                    },
                  },
                  items: this.itemsPaypal,
                  shipping: {
                    method: "Mondial Relay",
                    address: {
                      name: {
                        give_name: profile.firstName,
                        surname: profile.lastName,
                      },
                      address_line_1: this.pointRelais.adresse1,
                      address_line_2: this.pointRelais.adresse2,
                      admin_area_2: this.pointRelais.ville,
                      postal_code: this.pointRelais.cp,
                      country_code: "FR",
                    },
                  },
                },
              ],
            });
          },
          onApprove: (data, actions) => {
            this.$emit("update:canPay", false);
            this.loadingComponent = this.$buefy.loading.open();
            const produitAchetes = { ...this.panier };
            for (let index = 0; index < produitAchetes.liste.length; index++) {
              produitAchetes.liste[index] = { ...produitAchetes.liste[index] };
            }
            return actions.order.capture().then(async (details) => {
              const vente = new Vente(
                1,
                this.pointRelais,
                produitAchetes,
                this.panier.grammes,
                details,
                {
                  ...this.profile,
                }
              );

              await vente.ajoutVente();
              await this.panier.updateStock();
              this.panier.deleteAll();
              this.loadingComponent.close();
              this.$buefy.dialog.alert({
                title: "Achat effectué !",
                message: `Merci d'avoir acheté nos produits. <br> Vous allez recevoir dans les 24h un mail contenant votre facture ainsi que les détails pour suivre votre colis. <br> Pensez à vérifier vos courriers indésirables.`,
                type: "is-success",
                hasIcon: true,
                icon: "check",
                ariaRole: "alertdialog",
                ariaModal: true,
                onConfirm: () => {
                  this.$router.push("/");
                },
              });
            });
          },
          onError: (err) => {
            console.log(err);
            this.$emit("update:canPay", false);
            if (this.loadingComponent) {
              this.loadingComponent.close();
            }
            this.$buefy.dialog.alert({
              title: "Erreur",
              message:
                "Désolé mais une erreur est survenue. Si cela persiste contactez-nous rapidement via la page contact.",
              type: "is-danger",
              hasIcon: true,
              icon: "frown",
              ariaRole: "alertdialog",
              ariaModal: true,
              onConfirm: () => {
                this.$emit("update:canPay", true);
              },
            });
          },
        })
        .render(this.$refs.paypal);
    },
  },
};
</script>